import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { NegocioFormInsertWizardModule } from '../wizard';
import { NegocioFormInsertModalComponent } from './negocio-form-insert-modal.component';

@NgModule({
    imports: [
        SharedModule,
        NegocioFormInsertWizardModule
    ],
    declarations: [
        NegocioFormInsertModalComponent
    ],
    exports: [
        NegocioFormInsertModalComponent
    ]
})
export class NegocioFormInsertModalModule { }
